import { KeyboardEvent } from 'react';

/**
 * 한글 입력 중에 Enter, Tab 키 이벤트 처리를 위한 유틸리티 함수
 */
export const handleItemKeyDown = (
  e: KeyboardEvent<HTMLInputElement>,
  value: string,
  addItemFn: () => void
) => {
  if (e.nativeEvent.isComposing) return;

  if(e.key === 'Enter'){
    e.preventDefault();
    if (!value.trim()) {
      e.currentTarget.blur();
      return;
    }
  }
  
  if ((e.key === 'Enter' || e.key === 'Tab') && value.trim()) {
    e.preventDefault();
    addItemFn();
  }
};

/**
 * 참가자와 같은 항목을 목록에 추가하는 유틸리티 함수
 */
export const addItemToList = <T>(
  items: T[],
  newItem: T,
  isItemExist: (item: T) => boolean,
  setItems: (items: T[]) => void
): boolean => {
  if (isItemExist(newItem)) {
    return false;
  }
  
  setItems([...items, newItem]);
  return true;
};

/**
 * 목록에서 항목을 제거하는 유틸리티 함수
 */
export const removeItemFromList = <T>(
  items: T[],
  index: number,
  setItems: (items: T[]) => void
): void => {
  const updatedItems = [...items];
  updatedItems.splice(index, 1);
  setItems(updatedItems);
}; 